import { filter, pathOr, compose } from "ramda";
import { combineReducers } from "redux";
import { mergeReducers } from "core/redux/decorators";
import * as api from "./api";
import * as types from "./types";

const getCardsReducer = mergeReducers(
  api.getCards.reducer,
  (state = {}, action) => {
    switch (action.type) {
      case api.submitPayment.types.success:
        if (action.payload.request.type === "first") return state;

        return {
          ...state,
          data: {
            ...state.data,
            results: [
              action.payload.body,
              ...pathOr([], ["data", "results"], state)
            ]
          }
        };
      case api.deleteCard.types.success:
        return {
          ...state,
          data: {
            ...state.data,
            results: compose(
              filter(c => c.id !== action.payload.request),
              pathOr([], ["data", "results"])
            )(state)
          }
        };
      default:
        return state;
    }
  }
);

const uiReducer = (
  state = {
    isFormVisible: false,
    deletingCardId: void 0
  },
  action
) => {
  switch (action.type) {
    case types.SHOW_CREATE_FORM:
      return {
        ...state,
        isFormVisible: true
      };
    case types.HIDE_CREATE_FORM:
      return {
        ...state,
        isFormVisible: false
      };
    case api.deleteCard.types.request:
      return {
        ...state,
        deletingCardId: action.payload
      };
    case api.deleteCard.types.success:
      return {
        ...state,
        deletingCardId: void 0
      };
    default:
      return state;
  }
};

export default combineReducers({
  api: combineReducers({
    submitPayment: api.submitPayment.reducer,
    getCards: getCardsReducer,
    deleteCard: api.deleteCard.reducer,
    getInvoice: api.getInvoice.reducer,
    checkout: api.checkout.reducer,
    createInsiderPaymentInfo: api.createInsiderPaymentInfo.reducer,
    billingInfo: api.billingInfo.reducer,
    billingAccountBalance: api.billingAccountBalance.reducer
  }),
  ui: uiReducer
});



// WEBPACK FOOTER //
// ./src/modules/payment/reducer.js